import type {AssortmentType} from './types';

export const resolveAssortmentType = (
  locationType?: AssortmentType,
  nameSpace?: string
): AssortmentType | undefined => {
  if (locationType) {
    return locationType;
  }
  if (nameSpace === 'BSR') {
    return 'assortment region';
  }
  if (nameSpace === 'BSS') {
    return 'assortment vendor';
  }
  return undefined;
};
